export default __webpack_public_path__ + "static/media/resetSuccessimage.9f9b7a6f.svg";